/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { SharedHotelCurrencyAmount } from "./SharedHotelCurrencyAmount";
import {
  SharedHotelCurrencyAmountFromJSON,
  SharedHotelCurrencyAmountFromJSONTyped,
  SharedHotelCurrencyAmountToJSON,
  SharedHotelCurrencyAmountToJSONTyped,
} from "./SharedHotelCurrencyAmount";
import type { SharedHotelRawRateCharge } from "./SharedHotelRawRateCharge";
import {
  SharedHotelRawRateChargeFromJSON,
  SharedHotelRawRateChargeFromJSONTyped,
  SharedHotelRawRateChargeToJSON,
  SharedHotelRawRateChargeToJSONTyped,
} from "./SharedHotelRawRateCharge";
import type { RateType } from "./RateType";
import {
  RateTypeFromJSON,
  RateTypeFromJSONTyped,
  RateTypeToJSON,
  RateTypeToJSONTyped,
} from "./RateType";
import type { SharedHotelPointsAmount } from "./SharedHotelPointsAmount";
import {
  SharedHotelPointsAmountFromJSON,
  SharedHotelPointsAmountFromJSONTyped,
  SharedHotelPointsAmountToJSON,
  SharedHotelPointsAmountToJSONTyped,
} from "./SharedHotelPointsAmount";

/**
 *
 * @export
 * @interface SharedHotelRawRateSummary
 */
export interface SharedHotelRawRateSummary {
  /**
   *
   * @type {RateType}
   * @memberof SharedHotelRawRateSummary
   */
  rateType?: RateType;
  /**
   *
   * @type {string}
   * @memberof SharedHotelRawRateSummary
   */
  supplierRateName?: string;
  /**
   *
   * @type {SharedHotelCurrencyAmount}
   * @memberof SharedHotelRawRateSummary
   */
  totalCash?: SharedHotelCurrencyAmount;
  /**
   *
   * @type {SharedHotelCurrencyAmount}
   * @memberof SharedHotelRawRateSummary
   */
  totalRoomBaseRate?: SharedHotelCurrencyAmount;
  /**
   *
   * @type {SharedHotelCurrencyAmount}
   * @memberof SharedHotelRawRateSummary
   */
  averageNightlyRate?: SharedHotelCurrencyAmount;
  /**
   *
   * @type {SharedHotelCurrencyAmount}
   * @memberof SharedHotelRawRateSummary
   */
  taxesAndFees?: SharedHotelCurrencyAmount;
  /**
   *
   * @type {SharedHotelCurrencyAmount}
   * @memberof SharedHotelRawRateSummary
   */
  propertyFee?: SharedHotelCurrencyAmount;
  /**
   *
   * @type {SharedHotelCurrencyAmount}
   * @memberof SharedHotelRawRateSummary
   */
  totalDueAtProperty?: SharedHotelCurrencyAmount;
  /**
   *
   * @type {SharedHotelCurrencyAmount}
   * @memberof SharedHotelRawRateSummary
   */
  totalDueToday?: SharedHotelCurrencyAmount;
  /**
   *
   * @type {SharedHotelPointsAmount}
   * @memberof SharedHotelRawRateSummary
   */
  totalPoints?: SharedHotelPointsAmount;
  /**
   *
   * @type {SharedHotelPointsAmount}
   * @memberof SharedHotelRawRateSummary
   */
  averageNightlyPointsRate?: SharedHotelPointsAmount;
  /**
   *
   * @type {Array<SharedHotelRawRateCharge>}
   * @memberof SharedHotelRawRateSummary
   */
  deposits?: Array<SharedHotelRawRateCharge>;
  /**
   *
   * @type {Array<SharedHotelRawRateCharge>}
   * @memberof SharedHotelRawRateSummary
   */
  chargesDueAtProperty?: Array<SharedHotelRawRateCharge>;
}

/**
 * Check if a given object implements the SharedHotelRawRateSummary interface.
 */
export function instanceOfSharedHotelRawRateSummary(
  value: object
): value is SharedHotelRawRateSummary {
  return true;
}

export function SharedHotelRawRateSummaryFromJSON(
  json: any
): SharedHotelRawRateSummary {
  return SharedHotelRawRateSummaryFromJSONTyped(json, false);
}

export function SharedHotelRawRateSummaryFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): SharedHotelRawRateSummary {
  if (json == null) {
    return json;
  }
  return {
    rateType:
      json["rate_type"] == null
        ? undefined
        : RateTypeFromJSON(json["rate_type"]),
    supplierRateName:
      json["supplier_rate_name"] == null
        ? undefined
        : json["supplier_rate_name"],
    totalCash:
      json["total_cash"] == null
        ? undefined
        : SharedHotelCurrencyAmountFromJSON(json["total_cash"]),
    totalRoomBaseRate:
      json["total_room_base_rate"] == null
        ? undefined
        : SharedHotelCurrencyAmountFromJSON(json["total_room_base_rate"]),
    averageNightlyRate:
      json["average_nightly_rate"] == null
        ? undefined
        : SharedHotelCurrencyAmountFromJSON(json["average_nightly_rate"]),
    taxesAndFees:
      json["taxes_and_fees"] == null
        ? undefined
        : SharedHotelCurrencyAmountFromJSON(json["taxes_and_fees"]),
    propertyFee:
      json["property_fee"] == null
        ? undefined
        : SharedHotelCurrencyAmountFromJSON(json["property_fee"]),
    totalDueAtProperty:
      json["total_due_at_property"] == null
        ? undefined
        : SharedHotelCurrencyAmountFromJSON(json["total_due_at_property"]),
    totalDueToday:
      json["total_due_today"] == null
        ? undefined
        : SharedHotelCurrencyAmountFromJSON(json["total_due_today"]),
    totalPoints:
      json["total_points"] == null
        ? undefined
        : SharedHotelPointsAmountFromJSON(json["total_points"]),
    averageNightlyPointsRate:
      json["average_nightly_points_rate"] == null
        ? undefined
        : SharedHotelPointsAmountFromJSON(json["average_nightly_points_rate"]),
    deposits:
      json["deposits"] == null
        ? undefined
        : (json["deposits"] as Array<any>).map(
            SharedHotelRawRateChargeFromJSON
          ),
    chargesDueAtProperty:
      json["charges_due_at_property"] == null
        ? undefined
        : (json["charges_due_at_property"] as Array<any>).map(
            SharedHotelRawRateChargeFromJSON
          ),
  };
}

export function SharedHotelRawRateSummaryToJSON(
  json: any
): SharedHotelRawRateSummary {
  return SharedHotelRawRateSummaryToJSONTyped(json, false);
}

export function SharedHotelRawRateSummaryToJSONTyped(
  value?: SharedHotelRawRateSummary | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    rate_type: RateTypeToJSON(value["rateType"]),
    supplier_rate_name: value["supplierRateName"],
    total_cash: SharedHotelCurrencyAmountToJSON(value["totalCash"]),
    total_room_base_rate: SharedHotelCurrencyAmountToJSON(
      value["totalRoomBaseRate"]
    ),
    average_nightly_rate: SharedHotelCurrencyAmountToJSON(
      value["averageNightlyRate"]
    ),
    taxes_and_fees: SharedHotelCurrencyAmountToJSON(value["taxesAndFees"]),
    property_fee: SharedHotelCurrencyAmountToJSON(value["propertyFee"]),
    total_due_at_property: SharedHotelCurrencyAmountToJSON(
      value["totalDueAtProperty"]
    ),
    total_due_today: SharedHotelCurrencyAmountToJSON(value["totalDueToday"]),
    total_points: SharedHotelPointsAmountToJSON(value["totalPoints"]),
    average_nightly_points_rate: SharedHotelPointsAmountToJSON(
      value["averageNightlyPointsRate"]
    ),
    deposits:
      value["deposits"] == null
        ? undefined
        : (value["deposits"] as Array<any>).map(SharedHotelRawRateChargeToJSON),
    charges_due_at_property:
      value["chargesDueAtProperty"] == null
        ? undefined
        : (value["chargesDueAtProperty"] as Array<any>).map(
            SharedHotelRawRateChargeToJSON
          ),
  };
}
